'use strict';

import main from './lib/MilbGameUtils';

export default main;

